/**
 * Renders a horizontal gradient timeline showing days until policy expiration.
 * Bar fills from green (far away) → yellow → orange → red (today/overdue).
 */
const TIMELINE_WINDOW_DAYS = 365;

const colorForDays = (days) => {
  if (days == null) return "#94A3B8"; // slate-400
  if (days < 0) return "#7F1D1D"; // red-900 (overdue)
  if (days <= 7) return "#DC2626"; // red-600
  if (days <= 30) return "#F97316"; // orange-500
  if (days <= 90) return "#F59E0B"; // amber-500
  if (days <= 180) return "#84CC16"; // lime-500
  return "#16A34A"; // green-600
};

const labelForDays = (days) => {
  if (days == null) return "—";
  if (days < 0) return `Scaduta da ${Math.abs(days)} gg`;
  if (days === 0) return "Scade oggi";
  if (days <= 30) return `${days} gg`;
  if (days <= 365) return `${days} gg`;
  return "> 1 anno";
};

export const ExpiryTimeline = ({ endDate, status }) => {
  if (!endDate || status === "disdetta") {
    return <span className="text-xs text-slate-400">—</span>;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const end = new Date(endDate);
  end.setHours(0, 0, 0, 0);
  const days = Math.round((end.getTime() - today.getTime()) / 86400000);
  const color = colorForDays(days);
  // Percentage: 100% if days >= TIMELINE_WINDOW_DAYS, 0% if days <= 0
  const percent = Math.max(0, Math.min(100, (days / TIMELINE_WINDOW_DAYS) * 100));

  return (
    <div className="flex items-center gap-2 min-w-[120px]" data-testid="expiry-timeline">
      <div className="relative h-1.5 flex-1 rounded-full bg-slate-100 overflow-hidden">
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-all"
          style={{ width: `${percent}%`, background: `linear-gradient(90deg, #DC2626 0%, #F97316 25%, #F59E0B 50%, #84CC16 75%, #16A34A 100%)` }}
        />
        <div
          className="absolute top-1/2 -translate-y-1/2 h-2.5 w-2.5 rounded-full border-2 border-white shadow"
          style={{ left: `calc(${percent}% - 5px)`, background: color }}
        />
      </div>
      <span
        className="text-[10px] font-medium tabular-nums whitespace-nowrap"
        style={{ color }}
        data-testid="expiry-days"
      >
        {labelForDays(days)}
      </span>
    </div>
  );
};
